/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * @hidden
 */
var AccessTokenCacheItem = /** @class */ (function () {
    function AccessTokenCacheItem(key, value) {
        this.key = key;
        this.value = value;
    }
    return AccessTokenCacheItem;
}());
export { AccessTokenCacheItem };
//# sourceMappingURL=AccessTokenCacheItem.js.map


//////////////////
// WEBPACK FOOTER
// ./~/msal/lib-es6/cache/AccessTokenCacheItem.js
// module id = 1301
// module chunks = 0